import { useEffect, useState } from "react";

export default function ContentProtection() {
  const [warning, setWarning] = useState(false);
  useEffect(() => {
    const context = (event: MouseEvent) => { event.preventDefault(); setWarning(true); };
    const keys = (event: KeyboardEvent) => {
      const blocked = event.key === "F12" ||
        (event.ctrlKey && event.shiftKey && ["I", "J", "C"].includes(event.key.toUpperCase())) ||
        (event.ctrlKey && ["U", "S"].includes(event.key.toUpperCase()));
      if (blocked) { event.preventDefault(); event.stopPropagation(); setWarning(true); }
    };
    document.addEventListener("contextmenu", context);
    document.addEventListener("keydown", keys, true);
    return () => { document.removeEventListener("contextmenu", context); document.removeEventListener("keydown", keys, true); };
  }, []);
  useEffect(() => {
    if (!warning) return;
    const timer = window.setTimeout(() => setWarning(false), 2600);
    return () => window.clearTimeout(timer);
  }, [warning]);
  return warning ? <div className="content-protection-alert" role="alert">Conteúdo protegido. O acesso é pessoal e vinculado à sua conta.</div> : null;
}
